var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"no-body":""}},[_c('b-card-body',[_c('customer-document-detail',{ref:"customerParameterDetail",attrs:{"type":"edit","submitting":_vm.submitting,"values":_vm.data},on:{"submit":_vm.submit}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }